
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

interface LoadErrorProps {
  errorMessage: string;
  onBack: () => void;
  onRetry: () => void;
  isRetrying?: boolean;
}

export function LoadError({ 
  errorMessage, 
  onBack, 
  onRetry,
  isRetrying = false 
}: LoadErrorProps) {
  return (
    <Alert variant="destructive">
      <AlertTriangle className="h-4 w-4" />
      <AlertTitle>Error</AlertTitle>
      <AlertDescription>
        {errorMessage || 'Failed to load template. Please try again.'}
      </AlertDescription>
      <div className="flex gap-2 mt-4">
        <Button variant="outline" onClick={onBack}>
          Go Back
        </Button>
        <Button onClick={onRetry} disabled={isRetrying}>
          {isRetrying ? 'Retrying...' : 'Retry'}
        </Button>
      </div>
    </Alert>
  );
}
